<template>
  <div>
    <label class="control-label"
      >{{ title }}
      <span v-show="tempUpload" @click="clear" class="bold">
        - Отмена</span
      ></label
    >
    <div>
      <input
        ref="fileupload"
        accept="pdf/*"
        type="file"
        @change="handleFileUpload"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    tempUpload: false,
    oldData: null,
    noImage: require("@/assets/img/no-photo-available.png"),
  }),
  watch: {
    lastUpdate(val) {
      if (val) {
        this.tempUpload = false;
        this.$refs.fileupload.value = null;
      }
    },
  },
  computed: {
    ...mapState(["lastUpdate"]),
  },
  props: {
    title: {
      default: "",
    },
    value: {
      default: null,
    },
    isFile: {
      default: false,
    },
  },
  created() {
    this.oldData = this.value;
  },
  methods: {
    clear() {
      this.tempUpload = false;
      this.$refs.fileupload.value = null;
      this.$emit("input", this.oldData);
    },
    async handleFileUpload(event) {
      
      if (event.target.files && event.target.files.length > 0) {
        const file = event.target.files[0];
        if (file.size > 51000000) {
          this.$notify({
            title: "Ошибка",
            message: "Файл более 50 мб. весит",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "error",
          });
          return false;
        }

        if (this.isFile === true) {
          this.$emit("input", file);
          return true;
        }

        const reader = new FileReader();
        reader.readAsDataURL(file);
        await reader.addEventListener("load", () => {
          this.$emit("input", reader.result);
        });
      }
    },
  },
};
</script>
<style lang="scss">
</style>